// extracted by mini-css-extract-plugin
module.exports = {"description":"packageCardStyle_description__2ee3s"};